var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from 'aurelia-dependency-injection';
import { DialogClientService } from '../../../../../services/basics/dialog-client.service';
import * as Enumerable from 'linq';
import { TokenClient } from '../../../../../services/authentication/token-client.service';
var SelectTemplateDialog = /** @class */ (function () {
    function SelectTemplateDialog(dialogClient, tokenClient) {
        this.dialogClient = dialogClient;
        this.tokenClient = tokenClient;
    }
    SelectTemplateDialog.prototype.getImagePath = function (templatePath) {
        if (!templatePath) {
            return '';
        }
        var storageUri = this.tokenClient.storageUri;
        if (this.tokenClient.storageUri.endsWith('/')) {
            var substringed = this.tokenClient.storageUri.substr(0, this.tokenClient.storageUri.length - 1);
            storageUri = substringed;
        }
        var url = storageUri + templatePath;
        return url;
    };
    Object.defineProperty(SelectTemplateDialog.prototype, "templatesOrderedByName", {
        get: function () {
            if (this.vm && this.vm.templates)
                return Enumerable.from(this.vm.templates.values).orderBy(function (x) { return x.name; }).toArray();
            return [];
        },
        enumerable: false,
        configurable: true
    });
    SelectTemplateDialog.prototype.activate = function (model) {
        this.vm = model;
    };
    SelectTemplateDialog.prototype.cancel = function () {
        this.dialogClient.hide();
    };
    SelectTemplateDialog.prototype.select = function (template) {
        this.dialogClient.hide();
        this.vm.onTemplateSelected(template);
    };
    SelectTemplateDialog = __decorate([
        autoinject,
        __metadata("design:paramtypes", [DialogClientService, TokenClient])
    ], SelectTemplateDialog);
    return SelectTemplateDialog;
}());
export { SelectTemplateDialog };
